(function () {
  var MOBILE_BREAKPOINT = 768;
  var HIGH_RES_THRESHOLD = 800;

  function initSkeletons() {
    if (window.innerWidth > MOBILE_BREAKPOINT) return;

    document.querySelectorAll('.product-card__media').forEach(function (card) {
      var skeleton = card.querySelector('.product-card__skeleton');
      var img = card.querySelector('[data-skeleton-target]');

      if (!skeleton || !img) return;

      function hideSkeleton() {
        skeleton.classList.add('skeleton--hidden');
        skeleton.addEventListener('transitionend', function () {
          skeleton.remove();
        }, { once: true });
      }

      function evaluateAndHide() {
        if (img.naturalWidth < HIGH_RES_THRESHOLD) {
          skeleton.remove();
        } else {
          hideSkeleton();
        }
      }

      if (img.complete && img.naturalWidth > 0) {
        evaluateAndHide();
      } else {
        img.addEventListener('load', evaluateAndHide, { once: true });
        img.addEventListener('error', function () {
          skeleton.remove();
        }, { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSkeletons);
  } else {
    initSkeletons();
  }
})();